// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3N8ha","normal":"Button_normal__3-7Rl","red":"Button_red__3x3gu","gray":"Button_gray__3AOpP"};